import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("div", {
        class: "video_wrapper",
        key: _ctx.video.id
      }, [
        _createElementVNode("iframe", {
          ref: "aFrame",
          class: "video",
          src: _ctx.homelink,
          frameborder: "0",
          allow: "autoplay; fullscreen",
          allowfullscreen: "",
          mozallowfullscreen: "",
          webkitallowfullscreen: ""
        }, "Working", 8, _hoisted_2)
      ]))
    ])
  ]))
}